export default "/images/dc4aa584f5e746938909829a86ffa605.png";